<script setup lang="ts">
import { useDisplay } from 'vuetify/lib/framework'

const props = withDefaults(
  defineProps<{
    renderWithContainer?: boolean
    containerClass?: string
    maximumWidth?: string
  }>(),
  {
    renderWithContainer: true,
    containerClass: '',
    maximumWidth: '1920px',
  }
)

const { mobile } = useDisplay()
</script>

<template>
  <div :style="{ width: '100%', 'max-width': maximumWidth, margin: '0  auto' }">
    <v-container
      v-if="renderWithContainer"
      :style="mobile ? 'padding: 12px 16px;' : ''"
      :class="props.containerClass"
      fluid
    >
      <slot />
    </v-container>
    <slot v-else />
  </div>
</template>
